import React from 'react';
import AppRoutes from '@routes/index';

const App: React.FC = () => {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
};

export default App;
